import gql from 'graphql-tag';

export const removeQuestionMutation = gql`
  mutation RemoveQuestion($id: ID!) {
    removeQuestion(id: $id)
  }
`;